// import React, { useEffect, useState } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import { Box, Paper, Typography, TextField, Button, Stack, Alert, Divider } from '@mui/material';
// import { useAuth } from '../context/AuthContext';

// const UnitMaster = ({ mode, onPopupCancel, connectionString }) => {
//     const { user, selectedCompany } = useAuth();
//     const { id } = useParams();
//     const navigate = useNavigate();

//     const [formError, setFormError] = useState('');
//     const [unit, setUnit] = useState('');

//     const userId = user?.UserId || null;
//     const companyId = selectedCompany?.CompId || null;

//     // console.log(`From Unit master : ${userId} && ${companyId}`)

//     useEffect(() => {
//         if (mode === 'edit' && id) {
//             const fetchData = async () => {
//                 try {
//                     const response = await fetch(`${connectionString}/api/unit/getDetails/${id}`);
//                     const data = await response.json();
//                     setUnit(data.unit);
//                 } catch (error) {
//                     console.error('Error fetching unit data:', error);
//                 }
//             };
//             fetchData();
//         }
//     }, [id, mode]);

//     const funSubmit = async (e) => {
//         e.preventDefault();
//         setFormError('');

//         if (!unit.trim()) {
//             setFormError('Unit is required');
//             return;
//         }

//         try {
//             if (mode === 'add') {
//                 await axios.post(`${connectionString}/api/unit/Insert`, {
//                     unit,
//                     companyId,
//                     userId,
//                 });
//                 setUnit('');
//                 if (onPopupCancel) {
//                     onPopupCancel(); // Close dialog + refresh dropdown
//                 }
//             } else if (mode === 'edit') {
//                 await axios.put(`${connectionString}/api/unit/Update/${id}`, {
//                     unit,
//                     companyId,
//                     editUserId: userId,
//                 });
//             }

//             alert(mode === 'add' ? 'Data inserted successfully' : 'Data updated successfully');
//         } catch (error) {
//             console.error('Error inserting/updating data:', error);
//             alert(`Error ${mode === 'add' ? 'inserting' : 'updating'} data`);
//         }
//     };

//     const funReset = () => {
//         if (onPopupCancel) {
//             onPopupCancel();
//         } else {
//             setFormError('');
//             setUnit('');
//             navigate('/main/unitDetail');
//         }
//     };

//     return (
//         <Box p={3} maxWidth="600px" mx="auto">
//             <Paper elevation={3} sx={{ p: 4, borderRadius: 3, bgcolor: '#F0F8FF', border: '1px solid #e2e8f0', display: 'flex', flexDirection: 'column', }} >

//                 <Typography variant="h6" gutterBottom>
//                     {mode === "add" ? "Add New Unit" : "Edit Unit"}
//                 </Typography>
//                 <Divider sx={{ mb: 3 }} />

//                 <Box component="form" onSubmit={funSubmit} noValidate>
//                     <Stack spacing={3}>
//                         <TextField fullWidth label="Unit" size='small' value={unit} onChange={(e) => setUnit(e.target.value)} inputProps={{ maxLength: 4 }} required sx={{ '& .MuiInputBase-root': { height: 40 }, }} />

//                         {formError && <Alert severity="error">{formError}</Alert>}

//                         <Stack direction="column" spacing={2} alignItems="center">
//                             <Button type="submit" variant="contained" sx={{ textTransform: 'none', px: 4, width: 120}} >
//                                 {mode === 'add' ? 'Save' : 'Update'}
//                             </Button>
//                             <Button type="button" variant="outlined" color="error" onClick={funReset} sx={{ textTransform: 'none', px: 4, width: 120 }} >
//                                 Cancel
//                             </Button>
//                         </Stack>
//                     </Stack>
//                 </Box>
//             </Paper>
//         </Box>
//     );
// };

// export default UnitMaster;

//****************using suggestion and autofill */
// import React, { useEffect, useState, useRef } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import {
//   Box,
//   Paper,
//   Typography,
//   TextField,
//   Button,
//   Stack,
//   Alert,
//   Divider,
//   Chip
// } from '@mui/material';

// import { useAuth } from '../context/AuthContext';
// import { unitData } from '../utils/unitData';

// // simple Levenshtein distance check
// const levenshtein = (a, b) => {
//   if (!a.length) return b.length;
//   if (!b.length) return a.length;

//   const dp = Array(a.length + 1)
//     .fill(null)
//     .map(() => Array(b.length + 1).fill(0));

//   for (let i = 0; i <= a.length; i++) dp[i][0] = i;
//   for (let j = 0; j <= b.length; j++) dp[0][j] = j;

//   for (let i = 1; i <= a.length; i++) {
//     for (let j = 1; j <= b.length; j++) {
//       const cost = a[i - 1] === b[j - 1] ? 0 : 1;
//       dp[i][j] = Math.min(
//         dp[i - 1][j] + 1,
//         dp[i][j - 1] + 1,
//         dp[i - 1][j - 1] + cost
//       );
//     }
//   }
//   return dp[a.length][b.length];
// };

// const UnitMaster = ({ mode, onPopupCancel, connectionString }) => {
//   const { user, selectedCompany } = useAuth();
//   const { id } = useParams();
//   const navigate = useNavigate();

//   const [formError, setFormError] = useState('');
//   const [unit, setUnit] = useState('');
//   const [description, setDescription] = useState('');
//   const [didYouMean, setDidYouMean] = useState(null);

//   const typingTimeout = useRef(null);

//   const userId = user?.UserId || null;
//   const companyId = selectedCompany?.CompId || null;

//   useEffect(() => {
//     if (mode === 'edit' && id) {
//       const fetchData = async () => {
//         try {
//           const res = await fetch(`${connectionString}/api/unit/getDetails/${id}`);
//           const data = await res.json();
//           setUnit(data.unit);
//           setDescription(data.description || '');
//         } catch (err) {
//           console.error('Error fetching unit data:', err);
//         }
//       };
//       fetchData();
//     }
//   }, [id, mode]);

//   const handleUnitChange = (value) => {
//     const upper = value.toUpperCase();
//     setUnit(upper);
//     setDidYouMean(null);

//     if (typingTimeout.current) clearTimeout(typingTimeout.current);

//     typingTimeout.current = setTimeout(() => {
//       const exact = unitData.find(u => u.code === upper);

//       // exact match → fill + clear suggestion
//       if (exact) {
//         setDescription(exact.desc);
//         setDidYouMean(null);
//         return;
//       }

//       // fuzzy match (levenshtein)
//       if (upper.length >= 2) {
//         const closeMatches = unitData
//           .map(u => ({ ...u, d: levenshtein(upper, u.code) }))
//           .filter(u => u.d <= 2)
//           .sort((a, b) => a.d - b.d);

//         if (closeMatches.length > 0) {
//           setDidYouMean(closeMatches[0]);
//           setDescription('');    // keep blank until user clicks!
//           return;
//         }
//       }

//       // if we reach here → no matches at all
//       setDidYouMean(null);
//       setDescription('');
//     }, 600);

//   };

//   const applySuggestion = () => {
//     if (!didYouMean) return;
//     setUnit(didYouMean.code);
//     setDescription(didYouMean.desc);
//     setDidYouMean(null);
//   };

//   console.log("unit", unit)

//   const funSubmit = async (e) => {
//     e.preventDefault();
//     setFormError('');

//     if (!unit.trim()) return setFormError('Unit is required');
//     if (!description.trim()) return setFormError('Description is required');

//     try {
//       if (mode === 'add') {
//         await axios.post(`${connectionString}/api/unit/Insert`, {
//           unit,
//           description,
//           companyId,
//           userId,
//         });

//         setUnit('');
//         setDescription('');
//         if (onPopupCancel) onPopupCancel();
//       } else {
//         await axios.put(`${connectionString}/api/unit/Update/${id}`, {
//           unit,
//           description,
//           companyId,
//           editUserId: userId,
//         });
//       }

//       alert(mode === 'add' ? 'Data inserted successfully' : 'Data updated successfully');
//     } catch (error) {
//       console.error('Error inserting/updating data:', error);
//       alert(`Error ${mode === 'add' ? 'inserting' : 'updating'} data`);
//     }
//   };

//   const funReset = () => {
//     if (onPopupCancel) {
//       onPopupCancel();
//     } else {
//       setFormError('');
//       setUnit('');
//       setDescription('');
//       navigate('/main/unitDetail');
//     }
//   };

//   return (
//     <Box p={3} maxWidth="600px" mx="auto">
//                  <Paper
//                      elevation={3}
//                      sx={{
//                          p: 4,
//                          borderRadius: 3,
//                          bgcolor: '#FAFAFA',
//                          border: '1px solid #e2e8f0',
//                      }}
//                  >
//          <Typography
//                            variant="h6"
//                            gutterBottom
//                            sx={{ fontWeight: 600, color: '#1f2937', textAlign: 'center' }}
//                        >
//           {mode === 'add' ? 'Add New Unit' : 'Edit Unit'}
//         </Typography>

//         <Box component="form" onSubmit={funSubmit} noValidate autoComplete="off">
//           <Stack spacing={3}>
//             <Box sx={{ position: 'relative' }}>
//               <TextField
//                 fullWidth
//                 size="small"
//                 label="Unit"
//                 value={unit}
//                 onChange={(e) => handleUnitChange(e.target.value)}
//                 inputProps={{
//                   maxLength: 4,
//                   autoComplete: "off",
//                   form: { autoComplete: "off" }
//                 }}
//                 autoComplete="off"

//                 required

//               />

//               {didYouMean && (
//                 <Box
//                   onClick={applySuggestion}
//                   sx={{
//                     position: 'absolute',
//                     top: '50px', // adjust if needed
//                     left: '10px',
//                     backgroundColor: '#ffffff',
//                     borderRadius: '6px',
//                     border: '1px solid #e2e8f0',
//                     boxShadow: '0px 4px 12px rgba(0,0,0,0.12)',
//                     px: 1.5,
//                     py: 0.5,
//                     cursor: 'pointer',
//                     fontSize: '0.85rem',
//                     color: '#374151',
//                     whiteSpace: 'nowrap',
//                     zIndex: 1000,
//                     display: 'flex',
//                     alignItems: 'center',
//                     '&:hover': {
//                       backgroundColor: '#f8fafc',
//                     },
//                     '&::after': {
//                       content: '""',
//                       position: 'absolute',
//                       top: '-5px',
//                       left: '14px',
//                       width: '0',
//                       height: '0',
//                       borderLeft: '6px solid transparent',
//                       borderRight: '6px solid transparent',
//                       borderBottom: '6px solid #ffffff',
//                       filter: 'drop-shadow(0 -1px 1px rgba(0,0,0,0.15))'
//                     }
//                   }}
//                 >
//                   {`Did you mean ${didYouMean.code} ?`}
//                 </Box>
//               )}


//             </Box>

//             <TextField
//               fullWidth
//               size="small"
//               label="Description"
//               value={description}
//               onChange={(e) => setDescription(e.target.value)}
//               required
//               autoComplete="off"
//               inputProps={{
//                 autoComplete: "off",
//                 form: { autoComplete: "off" }
//               }}
//             />

//             {formError && <Alert severity="error">{formError}</Alert>}

//             <Stack direction="row" spacing={2} justifyContent="center">
//               <Button type="submit" variant="contained">
//                 {mode === 'add' ? 'Save' : 'Update'}
//               </Button>
//               <Button type="button" variant="contained" color="error"
//                 onClick={funReset}>
//                 Cancel
//               </Button>
//             </Stack>
//           </Stack>
//         </Box>
//       </Paper>
//     </Box>
//   );
// };

// export default UnitMaster;



//************simple user inputs of unit and description*************

import { gradients } from '../utils/theme';
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import {
    Box,
    Typography,
    TextField,
    Button,
    Stack,
    Alert,
    Snackbar,
    Divider
} from '@mui/material';

import { useAuth } from '../context/AuthContext';
// import { unitData } from '../utils/unitData'; // still using to check duplicates (optional)

const UnitMaster = ({ id, mode, onPopupCancel, connectionString, units, companyId: propsCompanyId }) => {
    const { user, selectedCompany } = useAuth();
    // const { id } = useParams();
    const { id: routeId } = useParams();
    const recordId =
        mode === 'edit'
            ? id           // dialog edit → HSNId
            : routeId;
    const navigate = useNavigate();

    const [formError, setFormError] = useState('');
    const [unit, setUnit] = useState('');
    const [description, setDescription] = useState('');

    const userId = user?.UserId || null;
    const companyId = (mode === 'comp' || mode === 'edit')
        ? propsCompanyId              // Use props when called from HSNModule
        : selectedCompany?.CompId;
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
    const AppRegID = selectedCompany?.AppRegID || null;

    console.log("Units", units)

    const requiredAsteriskStyle = {
        '& .MuiFormLabel-asterisk': {
            color: 'red',
        },
    };

    // Fetch existing in Edit mode
    useEffect(() => {
        if (mode === 'edit' && recordId) {
            const fetchData = async () => {
                try {
                    const res = await fetch(`${connectionString}/api/unit/getDetails/${recordId}`);
                    const data = await res.json();
                    setUnit(data.Unit || '');
                    setDescription(data.UnitDescription || '');
                } catch (err) {
                    console.error('Error fetching unit data:', err);
                }
            };
            fetchData();
        }
    }, [recordId, mode, connectionString]);

    const funSubmit = async (e) => {
        e.preventDefault();
        setFormError('');

        const enteredUnit = unit.trim().toUpperCase();

        // Validation
        if (!enteredUnit) return setFormError('Unit is required');

        // 🔥 Check duplicate (only in Add mode OR new unit entered)
        if (mode === 'add' || mode === 'comp' || (mode === 'edit' && enteredUnit !== unit)) {
            const existsInStatic = units?.some((u) => u.value === enteredUnit);
            console.log(existsInStatic)
            if (existsInStatic) {
                return setFormError(`Unit '${enteredUnit}' already exists`);
            }

            // Optional: check duplicate from DB
            // const checkRes = await axios.get(`${connectionString}/api/unit/check/${enteredUnit}`);
            // if (checkRes.data.exists) return setFormError(`Unit '${enteredUnit}' already exists`);
        }

        try {
            if (mode === 'add' || mode === 'comp') {
                await axios.post(`${connectionString}/api/unit/Insert`, {
                    unit: enteredUnit,
                    description,
                    companyId,
                    userId,
                    AppRegID
                });

                setUnit('');
                setDescription('');
                setSnackbar({ open: true, message: 'Data inserted successfully', severity: 'success' });
                if (onPopupCancel) {
                    setTimeout(() => { onPopupCancel() }, 600)
                }
            } else {
                await axios.put(`${connectionString}/api/unit/Update/${recordId}`, {
                    unit: enteredUnit,
                    description,
                    companyId,
                    AppRegID,
                    editUserId: userId,
                });
                setSnackbar({ open: true, message: 'Data updated successfully', severity: 'success' });
                if (onPopupCancel) {
                    setTimeout(() => {
                        onPopupCancel({ unitAdded: true });  // ✅ Signal back
                    }, 600)
                }
            }
        } catch (error) {
            console.error('Error inserting/updating data:', error);
            setSnackbar({ open: true, message: `Error ${mode === 'add' || mode === 'comp' ? 'inserting' : 'updating'} data`, severity: 'error' });
        }
    };

    const funReset = () => {
        if (onPopupCancel) {
            onPopupCancel();
        } else {
            setFormError('');
            setUnit('');
            setDescription('');
            navigate('/main/unitDetail');
        }
    };

    // ──────────────── Alt+S (Save/Update) & Alt+C (Cancel) shortcuts ────────────────
    // Attached to document in the capture phase so it fires regardless of which
    // field/dropdown currently has focus, including MUI popper/portal content.
    // Uses e.code (physical key position) instead of e.key so this also works on
    // macOS, where Option+letter often produces an accented/dead-key character
    // via e.key (e.g. Option+C → "ç") instead of the plain letter.
    useEffect(() => {
        const handleGlobalKeyDown = (e) => {
            if (!e.altKey) return;

            if (e.code === "KeyS") {
                e.preventDefault();
                funSubmit(e);
            } else if (e.code === "KeyC") {
                e.preventDefault();
                funReset();
            }
        };

        document.addEventListener("keydown", handleGlobalKeyDown, true);
        return () => document.removeEventListener("keydown", handleGlobalKeyDown, true);
    });

    return (
        <>
            <Box sx={{ height: 4, background: gradients.primaryRow }} />
            <Box sx={{ px: 2.5, pt: 2, pb: 1.5 }}>
                <Typography variant="h6" fontWeight={700} color="primary.main" sx={{ fontSize: '1.05rem' }}>
                    {mode === 'add' || mode === 'comp' ? 'Add New Unit' : 'Edit Unit'}
                </Typography>
            </Box>
            <Divider />
            <Box component="form" onSubmit={funSubmit} noValidate autoComplete="off">
                <Box sx={{ px: 2.5, pt: 2, pb: 0.5 }}>
                    <Stack spacing={2}>
                        <TextField
                            fullWidth
                            size="small"
                            label="Unit"
                            value={unit}
                            onChange={(e) => { setUnit(e.target.value.toUpperCase()); setFormError(''); }}
                            inputProps={{ maxLength: 3 }}
                            required
                            InputLabelProps={{ sx: requiredAsteriskStyle }}
                            sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }}
                        />
                        <TextField
                            fullWidth
                            size="small"
                            label="Description"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }}
                        />
                        {formError && <Alert severity="error">{formError}</Alert>}
                    </Stack>
                </Box>
                <Divider sx={{ mt: 1.5 }} />
                <Box sx={{ px: 2.5, py: 1.5, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    <Button type="button" variant="outlined" color="inherit" size="small" onClick={funReset}>
                        Cancel
                    </Button>
                    <Button type="submit" variant="contained" size="small">
                        {mode === 'add' || mode === 'comp' ? 'Save' : 'Update'}
                    </Button>
                </Box>
            </Box>
            <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} open={snackbar.open} autoHideDuration={3000} onClose={() => setSnackbar({ ...snackbar, open: false })}>
                <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity} sx={{ width: '100%' }} variant='filled'>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </>
    );
};

export default UnitMaster;

